import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import DateFnsUtils from "@date-io/date-fns";

import DetailCard from "../../../common/DetailCard/DetailCard";
import ConfirmationModal from "../../../common/ConfirmationModal/ConfirmationModal";
import { deleteData } from "../../../../actions/candidateEntry";

import { EditIcon, TrashIcon } from "../../Icons";
import { Grid } from "@material-ui/core";

import "./WorkExperience.scss";

const dateFns = new DateFnsUtils();

const WorkExperienceDetails = ({ handleClick }) => {
  const dispatch = useDispatch();
  const { candidateData } = useSelector((state) => state);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [isDeleting, setDeleting] = useState(false);
  const [workId, setWorkId] = useState();

  const handleDeleteClick = async (id) => {
    setConfirmationOpen(true);
    setWorkId(id);
  };

  const confirmDeletion = async () => {
    setDeleting(true);
    try {
      await dispatch(deleteData('work', workId));
    } catch (err) {
      console.log(err);
    }
  };

  const { work: workList } = candidateData;
  return (
    <>
      <div className="work-details-card" data-testid="work-details">
        {workList && (
          <DetailCard title="Job Experience" handleClick={handleClick}>
            {workList.map((work, index) => (
              <div className="details-card" key={index}>
                <Grid container>
                  <Grid item className="work-details" xs={9} sm={9} md={9} lg={9}>
                    <div className="details">
                      {work.position && <h3 className="text-lg font-medium text-gray-900 truncate">{work.position}</h3>}
                      {work.startDate && (
                        <p className="text-sm font-smalltext-gray-900">{`${dateFns.format(
                          new Date(work.startDate),
                          "MMMM yyyy"
                        )} - ${
                          !work.present && work.endDate
                            ? dateFns.format(new Date(work.endDate), "MMMM yyyy")
                            : "Present"
                        }`}</p>
                      )}
                      <p className="text-sm font-smalltext-gray-900">{work.facility}</p>
                      <p className="text-sm font-smalltext-gray-900">{work.location}</p>
                    </div>
                  </Grid>
                  <Grid item className="main-content buttons" xs={3} sm={3} md={3} lg={3}>
                    <div onClick={handleClick} data-testid="editClick" className="icon-button edit">
                      <EditIcon iconClass="blue-icon" />
                    </div>
                    <div onClick={() => handleDeleteClick(work.id)} data-testid="deleteClick" className="icon-button">
                      <TrashIcon className="delete-icon" />
                    </div>
                  </Grid>
                </Grid>
              </div>
            ))}
          </DetailCard>
        )}
      </div>
      {confirmationOpen && (
        <ConfirmationModal
          open={confirmationOpen}
          confirm={() => confirmDeletion()}
          handleClose={() => setConfirmationOpen(false)}
          loading={isDeleting}
          message="Are you sure you want to delete this work experience?"
          cancelButtonText="Cancel"
        />
      )}
    </>
  );
};

export default WorkExperienceDetails;
